import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, Typography } from "@mui/material";
import React from "react";

interface SelectActiveCalibrationProps {
    sites: Record<string, { asset_id: string; timeserie_id: number; name: string }>;
    handleSelectedSite: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const SelectActiveCalibration: React.FC<SelectActiveCalibrationProps> = ({ sites, handleSelectedSite }) => {
	return (
		<Box marginTop={10}>
			<Typography sx={{ fontSize: "1.25rem" }}>
				Make respy calibration active
			</Typography>
			<FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
				<FormGroup>
					{Object.values(sites).map((site) => (
						<FormControlLabel
							key={site.asset_id}
							control={
								<Checkbox
									onChange={handleSelectedSite}
									value={site.asset_id}
								/>
							}
							label={site.name}
						/>
					))}
				</FormGroup>
			</FormControl>
		</Box>
	);
};

export default SelectActiveCalibration;
